var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fw3"
  }, [_c('div', [_c('div', {
    staticClass: "f3"
  }, [(_vm.beer.brewery) ? _c('span', {
    staticClass: "fw7 pr1 dib"
  }, [_vm._v(_vm._s(_vm.breweriesMap[_vm.beer.brewery].name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "nowrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.beer.name))]), _vm._v(" "), (_vm.beer.degrees) ? _c('span', [_vm._v(_vm._s(_vm.beer.degrees) + "°")]) : _vm._e()])]), _vm._v(" "), (_vm.beer.type) ? _c('div', {
    staticClass: "i lh-solid nowrap"
  }, [_vm._v("\n      " + _vm._s(_vm.beerTypesMap[_vm.beer.type].name) + "\n      "), (_vm.beer.alcohol) ? _c('span', [_vm._v(_vm._s(_vm.beer.alcohol)), _c('smp-hair'), _vm._v("%")], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.beer.kegRemainingFraction) ? _c('div', {
    staticClass: "relative ph3 pv1 bg-black-10 mb2 mt1",
    attrs: {
      "title": "hladina pivného sudu"
    }
  }, [_c('div', {
    staticClass: "absolute left-0 top-0 h-100 pv1",
    class: ("bg-" + _vm.remainingColor),
    style: ({
      width: ((_vm.beer.kegRemainingFraction * 100) + "%")
    })
  }), _vm._v(" "), (_vm.remainingColor !== 'green') ? _c('div', {
    staticClass: "relative sans-serif tr f4 b lh-solid",
    class: _vm.remainingColor,
    staticStyle: {
      "text-shadow": "-1px -1px 0 #e5e5e5, 1px -1px 0 #e5e5e5, -1px 1px 0 #e5e5e5, 1px 1px 0 #e5e5e5"
    }
  }, [(_vm.remainingColor === 'red') ? [_vm._v("zostáva menej než 10 pív!")] : _vm._e(), _vm._v(" "), (_vm.remainingColor === 'orange') ? [_vm._v("zostáva menej než 20 pív!")] : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tr"
  }, [(_vm.beer.price03) ? _c('span', [_c('span', [_vm._v("0,3"), _c('smp-hair'), _vm._v("l")], 1), _vm._v(" "), _c('span', {
    staticClass: "price sans-serif b"
  }, [_vm._v(_vm._s(_vm.beer.price03)), _c('smp-hair'), _vm._v("€")], 1)]) : _vm._e(), _vm._v(" "), (_vm.beer.price04) ? _c('span', {
    staticClass: "ml4"
  }, [_c('span', [_vm._v("0,4"), _c('smp-hair'), _vm._v("l")], 1), _vm._v(" "), _c('span', {
    staticClass: "price sans-serif b"
  }, [_vm._v(_vm._s(_vm.beer.price04)), _c('smp-hair'), _vm._v("€")], 1)]) : _vm._e(), _vm._v(" "), (_vm.beer.price05) ? _c('span', [_c('span', [_vm._v("0,5"), _c('smp-hair'), _vm._v("l")], 1), _vm._v(" "), _c('span', {
    staticClass: "price sans-serif b"
  }, [_vm._v(_vm._s(_vm.beer.price05)), _c('smp-hair'), _vm._v("€")], 1)]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb6ae1d","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BeerItem.vue
// module id = 89
// module chunks = 1